import { PersonsView } from './PersonsView';
import { usePersonsTrackLanes } from '../hooks/usePersonsTrackLanes';

/**
 * Stream audit "Personas" tab entry.
 *
 * Loads focus-clipped lanes from {@link usePersonsTrackLanes} (shared with the
 * track via {@link PersonsLanesProvider}) and renders the results table.
 */
export function PersonsContainer() {
  const { lanes, range, isLoading } = usePersonsTrackLanes();

  return <PersonsView lanes={lanes} loading={isLoading} range={range} />;
}
